import { Box, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";

export const LoadingSkeleton = () => (
  <Box sx={{ py: 4 }}>
    {/* Stepper (VendorStepper: 2 steps, centered, responsive width) */}
    <Box sx={{ maxWidth: { xs: 500, xxl: 625, uhd: 750 }, mx: "auto", mb: 6 }}>
      <Stack direction="row" spacing={2} justifyContent="space-between">
        <Stack alignItems="center" spacing={1} sx={{ flex: 1 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width="60%" height={20} />
        </Stack>
        <Stack alignItems="center" spacing={1} sx={{ flex: 1 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width="60%" height={20} />
        </Stack>
      </Stack>
    </Box>

    {/* Vendor cards (VendorSelector: 3 full-width VendorCards) + Continue button */}
    <Stack spacing={4}>
      <Grid container spacing={2.5}>
        <Grid size={12}>
          <Skeleton variant="rounded" height={89} sx={{ borderRadius: 3 }} />
        </Grid>
        <Grid size={12}>
          <Skeleton variant="rounded" height={89} sx={{ borderRadius: 3 }} />
        </Grid>
        <Grid size={12}>
          <Skeleton variant="rounded" height={89} sx={{ borderRadius: 3 }} />
        </Grid>
      </Grid>

      <Stack direction="row" justifyContent="flex-end" spacing={1}>
        <Skeleton variant="rounded" width={120} height={36} />
      </Stack>
    </Stack>
  </Box>
);
